import type { CreateOfferDTO } from "src/api/models";
// import { postCreateOffer } from "src/api/queries/order-portal-bff";
import { useNotification } from "src/composables/useNotification";
import { customInstance } from "src/api/mutator/axios";
import { postSendOffer } from "src/api/queries/order-portal-bff";
import { toUTCDateTimeString } from "src/utils/date-utc";

export interface CreateOfferResult {
  success: boolean;
  offerId?: string;
  error?: string;
}

export interface SendOfferResult {
  success: boolean;
  error?: string;
}

export function useOfferService() {
  const { showSuccess, showError } = useNotification();

  async function createOffer(data: CreateOfferDTO): Promise<CreateOfferResult> {
    try {
      // const response = await postCreateOffer(data);
      showSuccess({ message: "Offer created successfully" });
      return {
        success: true,
        // offerId: response as unknown as string,
      };
    } catch (error) {
      const message = "Failed to create offer";
      showError({ message });
      return {
        success: false,
        error: message,
      };
    }
  }

  async function sendOffer(ticketId: string): Promise<SendOfferResult> {
    try {
      const currentDateTime = toUTCDateTimeString(new Date());
      await postSendOffer({ ticket_id: ticketId, layout: "service-offer", project: "vanderkreeft", version_date: currentDateTime });
      showSuccess({ message: "Offer sent successfully" });
      return { success: true };
    } catch (error) {
      const message = "Failed to send offer";
      showError({ message });
      return { success: false, error: message };
    }
  }

  return {
    createOffer,
    sendOffer,
  };
}
